// Auto-generated from proto definitions. DO NOT EDIT.

export type JwtSigningAlgorithm = 'JWT_SIGNING_ALGORITHM_UNSPECIFIED' | 'JWT_SIGNING_ALGORITHM_EDDSA' | 'JWT_SIGNING_ALGORITHM_RS256' | 'JWT_SIGNING_ALGORITHM_ES256';

export const JwtSigningAlgorithmValues = ['JWT_SIGNING_ALGORITHM_UNSPECIFIED', 'JWT_SIGNING_ALGORITHM_EDDSA', 'JWT_SIGNING_ALGORITHM_RS256', 'JWT_SIGNING_ALGORITHM_ES256'] as const;
